










import Vue from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    props: {
        tier: {
            type: String,
            required: true
        },
        upgrade: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        loading: false,
        startStarterCopy: `Upgrade to the Starter Subscription for $19 per month to Broadcast up to 50 contacts at once.
                            <br><br>
                            By proceeding, you'll start your subscription right away and be charged immediately.
                            <br><br>
                            If you'd like to explore our other subscription options please go to Settings -> Subscription Settings`,
        startOperatorCopy: `Upgrade to the Operator Subscription for $49 per month to Broadcast up to 1,000 contacts at once.
                            <br><br>
                            By proceeding, you'll start your subscription right away and be charged immediately.
                            <br><br>
                            If you'd like to explore our other subscription options please go to Settings -> Subscription Settings`,
        startTeamCopy: `Upgrade to the Team subscription for $159 per month to reach up to 2,000 contacts at once.
                        <br><br>
                        By proceeding, you'll start your subscription right away and be charged immediately. 
                        <br><br>
                        If you'd like to explore our other subscription options please go to Settings -> Subscription Settings`,
        upgradeOperatorCopy: `Upgrade to the Operator plan to Broadcast up to 1,000 contacts at once.
                            <br><br>
                            By upgrading, you'll start your subscription right away and be charged. If you'd like to start a free trial of a different plan, please contact us directly via email at sales@messagedesk.com to see if you're eligible.`,
        upgradeTeamCopy: `Upgrade to the Team subscription for $159 per month to reach up to 2,000 contacts at once.
                        <br><br>
                        By proceeding, you'll start your subscription right away and be charged immediately. 
                        <br><br>
                        If you'd like to explore our other subscription options please go to Settings -> Subscription Settings`
    }),
    computed: {
        ...mapGetters(['getPlan', 'plan']),
        btnText(): string {
            //  Our button text depends on the tier
            const text = {
                Starter: 'Upgrade to Starter ($19 per month)',
                Operator: 'Upgrade to Operator ($49 per month)',
                Team: 'Upgrade to Team ($159 per month)'
            }[this.tier]

            //  Return our text
            return text
        },
        text(): string {
            //  Our pop up text depends on the tier
            const text = {
                Starter: this.startStarterCopy,
                Operator: this.startOperatorCopy,
                Team: this.startTeamCopy
            }[this.tier]

            //  Return our text
            return text
        }
    },
    methods: {
        async upgradeSubscription(): Promise<void> {
            //  Our tier comes from the prop
            const tier = this.tier

            //  Grab our current plan
            const curr = this.plan

            //  Get the interval from this plan
            const interval = curr.interval

            //  Grab our plan based on this tier
            const plan = this.getPlan(tier, interval)

            //  Create our payload
            const payload = plan

            //  Make sure we set users to 0
            payload.users = 0

            //  Start loading
            this.loading = true

            //  Send the request to the API
            const subscription = await this.$store.dispatch('subscriptionUpdate', payload)

            //  Stop loading
            this.loading = false

            //  If it failed, do nothing
            if (!subscription) return

            //  Else, close the dialog
            this.$emit('submit')
        }
    }
})
